<div *ngIf="product">
  {{product?.title}} <small>&nbsp; {{platformTitle}}</small><br/>
  <small>{{version}}</small><br/>
  <small>{{licenseType | titlecase}}
  <br/>{{usageType | underscoreToSpace | titlecase}}</small>
</div>
